import React from "react";
import Step from "../Step.js";
import Explanation from "./concept.js";
import code from "./code.js";
import Code from "../Code.js";

const CommunicateStep = () => {
  return (
    <Step
      explanation={<Explanation />}
      code={
        <Code
          jsString={code}
          icon="edit"
          filename="P2p.js"
        />
      }
    />
  );
};

export default CommunicateStep;


// WEBPACK FOOTER //
// ./src/steps/communicate/step.js